<!-- eslint-disable -->

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useFooterSectionStore } from '@/stores/footer_sections';
import { useLanguagesStore } from '@/stores/languages';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import _ from 'lodash';

const footerSectionStore = useFooterSectionStore();
const languagesStore = useLanguagesStore();

const selected_language = ref(null);

onMounted(() => {
	selected_language.value = _.find(languagesStore.getLanguages,{ id: languagesStore.selectedLanguage.id });
});

const availableLanguages = computed(() => {
	return _.filter(languagesStore.getLanguages, (language) => language.id !== selected_language.value?.id);
});

const changeLanguage = () => {
	if (selected_language.value) {
		languagesStore.changeLanguage({ language_id: selected_language.value.id });
	}
};

</script>

<template>
	<template v-if="footerSectionStore.getLanguageSelectorSection">
		<div class="contact-flex">
			<Multiselect class="fixed-lang-select" v-model="selected_language" :options="availableLanguages" :show-labels="false" :searchable="false" @update:modelValue="changeLanguage">
				<template #option="{ option }">
					<div class="option-item">
						<img :src="footerSectionStore.getLanguageFlag(option.locale)" class="flag" />
						{{ $t('languages.' + option.name) }}
					</div>
				</template>
				<template #singleLabel="{ option }">
					<div class="selected-option">
						<img :src="footerSectionStore.getLanguageFlag(option.locale)" class="flag" />
						{{  $t('languages.' + option.name) }}
					</div>
				</template>
			</Multiselect>
		</div>
	</template>
</template>
<style scoped>

img.flag {
	width: 20px;
	margin-right: 16px;
}
html[dir="rtl"] img.flag {
	margin-right: unset;
	margin-left: 16px;
}
.selected-option {
	display: flex;
	justify-content: space-between;
	color: var(--white);
}
:deep(.multiselect__content-wrapper) {
	background: var(--dark-gray);
	color: var(--white);
	border:1px solid var(--dark-gray);
}
:deep(.multiselect__option--selected.multiselect__option--highlight) {
	background: var(--primary);
}
:deep(.multiselect__option--selected) {
	background: var(--primary);
}
:deep(.multiselect__option--highlight) {
	background: var(--light-dark);
}
.option-item {
	display: flex;
	align-items: center;
}
:deep(.multiselect__tags) {
	background: var(--dark-gray);
	border: 1px solid var(--dark-gray);
}
:deep(.multiselect__option--selected) {
	color: var(--white);
}
:deep(.multiselect__single) {
	background:var(--dark-gray);
}
.language-selector {
	width: 150px;
	padding: 8px 15px;
	background-color: var(--dark-gray);
	border-radius: 3px;
	font-size: 13px;
	font-weight: 300;
	height: 39px;
}
@media screen and (max-width: 767px) {
	.language-selector{
		margin-bottom:3%;
	}
}
.language-selector {
	background-image: url('@/assets/images/arrow-select.svg');
	background-repeat: no-repeat;
	background-position: center right 14px;
}
html[dir="rtl"] .language-selector {
	background-position: center left 14px;
}
.contact-flex {
	display: flex;
	align-items: flex-end;
	justify-items: start;
	flex-wrap: wrap;
	gap: 10px;
}
.contact-title {	color: var(--white);
	font-size: 13px;
	text-align: center;
	font-weight: 700;
	padding-bottom: 5px;
}
.contact-number {
	color: var(--primary);
	font-weight: 700;
	text-decoration: none;
}

.contact-number-ussd {
	color: var(--primary);
	font-weight: 700;
}

.no-hover {
	color: var(--primary);
	font-weight: 700;
	pointer-events: none;
	cursor: default;
}

.no-border {
	border: none;
	text-align: left;
}

@media screen and (max-width: 767px){
	.contact-flex {
		justify-content: space-between;
	}

	.btn-small {
		font-size: 13px;
		text-wrap: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mobile-width {
		width: 44%;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.btn-small {
		font-size: 13px;
		padding: 7px;
	}
}
</style>